import bindBitmovinToWebRTC from '../../webrtc/bindBitmovinToWebRTC';
import { Binder } from './interfaces';
import {
  BitmovinOptions,
  BitmovinPlayer,
  BitmovinPlayerConfig,
  BitmovinScript
} from '@kollective-frontend/ksdk-api';

declare global {
  interface Window {
    bitmovin: BitmovinScript;
  }
}

const setupBitmovinPlayer = (
  options: BitmovinOptions,
  binder: Binder
): BitmovinPlayer => {
  const player = generatePlayer(options, generateConfig(options, binder));
  const element = getVideoElement(options);
  if (element) {
    player.setVideoElement(element);
  }
  return player;
};
export default setupBitmovinPlayer;

export const generatePlayer = (
  options: BitmovinOptions,
  config: BitmovinPlayerConfig
): BitmovinPlayer => {
  const Player = ((window.bitmovin || {}).player || {}).Player;
  if (!Player) {
    if (options.generatePlayer) {
      return options.generatePlayer(options.container, config);
    }
    throw new Error('No bitmovin.player.player found, missing javascript');
  }
  return new Player(options.container, config) as BitmovinPlayer;
};

export const getVideoElement = (
  options: BitmovinOptions
): HTMLVideoElement | undefined => {
  if (options.element instanceof HTMLVideoElement) {
    return options.element;
  }
  if (!options.container || !(options.container instanceof HTMLElement)) {
    // We emit the error in the constructor for missing container
    return undefined;
  }
  const element = document.createElement('video');
  options.container.appendChild(element);
  return element;
};

export const generateConfig = (
  options: BitmovinOptions,
  binder: Binder
): BitmovinPlayerConfig => {
  const playerConfig = options.playerConfig || {};
  const network = playerConfig.network || {};
  return {
    ...playerConfig,
    network: {
      ...network,
      sendHttpRequest: bindBitmovinToWebRTC(binder)
    }
  };
};
